import type { Voucher } from '~/types';
import { BaseModel } from '~/models/base-model';

export class VoucherModel extends BaseModel<Voucher> {
    label = '';
}
